import styles from './TestNotificationsButton.module.css'
import { Button } from '@mui/material'
import ClearIcon from '@mui/icons-material/Clear'
import { useState } from 'react'
import { useSendTestNotificationMutation } from 'services/pushNotificationSubscription'
import { useEmailTestMutation } from 'entities/notifications/api/notificationsApi'

interface TestNotificationsButtonProps {
    onClick?: (event: any) => void
    subscribed?: boolean
    settings: any
}

export const TestNotificationsButton = (props: TestNotificationsButtonProps) => {
    const {
        onClick,
        subscribed,
        settings
    } = props

    const [disabledTestNotification, setDisabledTestNotification] = useState(false)

    const [
        trigger
    ] = useSendTestNotificationMutation()

    const [ 
        emailTest
    ] = useEmailTestMutation()

    const handleTestNotification = async () => {
        if (settings.emailNotificationsEnabled === true 
            && typeof settings.emailForNotifications === 'string' 
            && settings.emailForNotifications.length > 0
        ){
            emailTest()
        }

        setDisabledTestNotification(true);
        const registration = await navigator.serviceWorker.getRegistration();

        if (registration === undefined) {
            setDisabledTestNotification(false);
            return;
        }

        const subscription = await registration.pushManager.getSubscription();
        if (subscription) {
            trigger(subscription);
            setTimeout(() => {
                setDisabledTestNotification(false);
            }, 180000)
        }
        else {
            setDisabledTestNotification(false);
        }
    }

    const handleButtonClick = (event: any) => {
        handleTestNotification()
    }

    return (
        <button
            className={styles.TestNotificationsButton}
            onClick={handleButtonClick}
            type="button"
            disabled={disabledTestNotification || !subscribed}
        >
            {`Test Notifications`}
        </button>
    )
}